export default "__VITE_ASSET__CD0HYFQz__"